import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { RxCross1 } from 'react-icons/rx';
import { useSelector, useDispatch } from 'react-redux';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';
import { IoAddSharp } from 'react-icons/io5';
import { BarLoader } from 'react-spinners';
import AsyncSelect from 'react-select/async';
import Tooltip from './purchaseOrder2/tooltip';

const UpdateItemGrid = ({ onRequisitionData, setLoader, loder, itemData, selectedCheck, handleVatChange, isDiscountPercentage,
  currencyPrecision,
  setOverallDiscount, grandTotal, setVatAmount, vatAmount,
  overallDiscount, setDiscountAmount, discountAmount, setGrandTotal }) => {

  const rows = useSelector((state) => state.rows.rows);
  const [itemOptions, setItemOptions] = useState([]);
  const [descriptionOptions, setDescriptionOptions] = useState([]);
  const [vat, setvat] = useState([]);
  const dispatch = useDispatch();
  const apiService = new ApiService();

  const [page, setPage] = useState(1);
  const [desPage, setDecPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loader, setLoaders] = useState(false);

  // const calculatedTotal = rows.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0);
  const calculatedTotal = rows.reduce((sum, row) => {
    const qty = parseFloat(row?.qty) || 0;
    const unitPrice = parseFloat(row?.baseAmount) || 0;
    let final = (unitPrice * qty)
    return sum + (final);
  }, 0);

  // useEffect(() => {
  //   if (rows[0]?.ItemNo) {
  //     updatevat();
  //   }
  // }, [selectedCheck]);
  // Replace the existing useEffects in ItemGrid with these:

  useEffect(() => {
    fetchItemNo('', 1);
    fetchItemDesc('', 1);
    getVat();
  }, []);

  // Clear rows when itemData changes (important for dropdown changes)
  useEffect(() => {
    if (itemData?.requisitionNo) {
      // Clear existing rows when new itemData comes in
      dispatch(clearRows());
      setRows([]);
    }
  }, [itemData?.requisitionNo]); // React to requisition number changes

  // Process items when all dependencies are ready
  useEffect(() => {
    if (itemData) {
      getItems();
    }
  }, [itemData, overallDiscount]); // Add all necessary dependencies

  // Update VAT when selectedCheck changes
  // useEffect(() => {
  //   if (rows.length > 0 && rows[0]?.ItemNo) {
  //     updatevat();
  //   }
  // }, [selectedCheck]);

  useEffect(() => {
    const total = rows.reduce(
      (sum, row) => sum + Number(row?.amount || 0),
      0
    );
    const vatAmount = rows.reduce(
      (sum, row) => sum + Number(row?.vatAmount || 0),
      0
    );
    const vat = rows[0]?.vat || 0
    let calculatedfinal = calculatedTotal
    const discountAmt = (calculatedTotal * overallDiscount) / 100;
    let afterdiscount = (calculatedTotal - discountAmt)
    const grandtotals = (afterdiscount + vatAmount)
    const grandtotalsvat = (afterdiscount + vatAmount)
    let final = overallDiscount === 0 ? grandtotalsvat : grandtotals
    setDiscountAmount(discountAmt);
    setGrandTotal(final);
    setVatAmount(vatAmount)
  }, [rows, overallDiscount]);

  const updatevat = async () => {
    try {
      let vatParam = `?toPurchase=true`;
      const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
      setvat(vat.data.result);
      const updatedRows = rows.map((row) => ({ ...row }));
      const apiPromises = updatedRows.map(async (row, index) => {
        const selectedVat = vat.data.result?.find((tax) => tax.description === row?.vatDec);
        let amount = row?.qty * row?.baseAmount;
        const perAmount = (amount / 100) * (selectedVat?.rate || 0);
        let excludedAmount = amount + perAmount;
        const calculatedAmount = excludedAmount;
        let discountamount = row?.discount;
        let finalAmount = calculatedAmount;
        updatedRows[index].calculatedAmount = calculatedAmount;
        updatedRows[index].amount = finalAmount;
        updatedRows[index].vat = selectedVat?.rate || 0;
        updatedRows[index].vatDec = selectedVat?.description || 0;
        updatedRows[index].vatAmount = perAmount;
        updatedRows[index].discountAmount = discountamount;
        updatedRows[index].discount = row?.discount;
      });
      await Promise.all(apiPromises);
      setRows(updatedRows);
      onRequisitionData(updatedRows);
      dispatch(setRows(updatedRows));
    } catch (error) {
      console.error('Error updating rows with new stock:', error);
    }
  };
  const getVat = async () => {
    let vatParam = `?toPurchase=true`;
    const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
    setvat(vat.data.result);
  };
  const getItems = async () => {
    try {
      let vatParam = `?toPurchase=true`;
      const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
      setvat(vat.data.result);
      if (itemData?.requisitionNo) {
        setLoader(true);
        const requisitionNos = (itemData?.requisitionNo || "")
          .split(",")
          .map(item => item.trim())
          .filter(Boolean);

        let allPrDetails = [];

        // Fetch every PR
        for (const reqNo of requisitionNos) {
          const response = await apiService.getApiParamater(
            "GET_PR",
            `?Id=${encodeURIComponent(reqNo)}`
          );

          const selectedPR = response?.data?.result?.[0];

          if (selectedPR?.prDetails?.length) {
            allPrDetails.push(
              ...selectedPR.prDetails.map((prDetail) => ({ ...prDetail, requisitionNo: reqNo }))
            );
          }
        }

        // Sort merged PR Details
        const sortedPrDetails = allPrDetails.sort(
          (a, b) => Number(a.srno) - Number(b.srno)
        );
        const formattedRowsPromises = itemData?.poDetails
          ?.map(async (detail, index) => {
            const params = new URLSearchParams();
            params.append('ItemNo', detail.itemCode || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            let selecteditem = response?.data?.result[0];
            const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
            // PR matching is only a fallback to populate RequisitionNo/RSRNO on rows that were saved without
            // them. A saved detail row's own RequisitionNo/RSRNO must win when present — re-deriving them via
            // Specification text is unreliable (the saved specification can carry a user-added delivery-note
            // annotation that never matches the PR's raw specification) and silently overwrites correct data.
            const selectedPritem =
              sortedPrDetails.find(
                (pr) =>
                  pr?.itemCode === detail?.itemCode &&
                  (pr?.specification ?? '').trim() ===
                  (detail?.specification ?? '').trim()
              ) ||
              sortedPrDetails.find(
                (pr) =>
                  pr?.requisitionNo === detail?.requisitionNo &&
                  Number(pr?.srno) === Number(detail?.srno) &&
                  pr?.itemCode === detail?.itemCode
              ) ||
              sortedPrDetails[index];
            const selectedVat = vat.data.result?.find((tax) => tax?.description === detail?.vatDesc);

            if (!selecteditem) {
              console.error(`Selected item with description ${detail?.itemDescription} not found`);
              return null;
            }
            const amount = Number(detail?.qty || 0) * Number(detail?.unitPrice || 0);

            const discountPerc = Number(overallDiscount || 0);

            const discountAmount = (amount * discountPerc) / 100;

            const calculatedAmount = amount - discountAmount;

            const vatRate = Number(selectedVat?.rate || 0);

            const vatAmount = (calculatedAmount * vatRate) / 100;

            const totalAmount = calculatedAmount + vatAmount;
            debugger
            return {
              requisitionNo: selectedPritem?.requisitionNo || itemData.requisitionNo || '',
              srno: detail?.srno ?? detail?.srno,
              rsrno: selectedPritem?.srno,
              ItemNo: detail.itemCode,
              itemDescription: detail?.itemDescription,
              qty: detail?.qty,
              stock: selecteditem.convToInvUOM * detail?.qty,
              baseQty: selecteditem.convToInvUOM,
              uom: detail?.uom,
              baseAmount: detail.unitPrice?.toFixed(currencyPrecision || 3),
              discount: discountPerc,
              discountAmount: Number(discountAmount).toFixed(currencyPrecision),
              calculatedAmount: Number(calculatedAmount).toFixed(currencyPrecision),
              vat: vatRate,
              vatDec: selectedVat?.description,
              vatAmount: Number(vatAmount).toFixed(currencyPrecision),
              amount: Number(totalAmount).toFixed(currencyPrecision),
              specification: detail?.specification || selectedPritem?.specification || "",
            };
          })
          .filter((row) => row !== null);
        const formattedRows = await Promise.all(formattedRowsPromises);
        if (formattedRows?.length > 0) {
          setLoader(false);
          setRows(formattedRows);
          onRequisitionData(formattedRows);
          dispatch(setRows(formattedRows));
        }
      } else {
        setLoader(true);

        const formattedRowsPromises = itemData?.poDetails
          ?.map(async (detail, index) => {
            const params = new URLSearchParams();
            params.append('ItemNo', detail.itemCode || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            let selecteditem = response?.data?.result[0];

            const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
            const selectedVat = vat.data.result?.find((tax) => tax?.description === detail?.vatDesc);
            const amount = Number(detail?.qty || 0) * Number(detail?.unitPrice || 0);
            const discountPerc = Number(overallDiscount || 0);
            const discountAmount = (amount * discountPerc) / 100;
            const calculatedAmount = amount - discountAmount;
            const vatRate = Number(selectedVat?.rate || 0);
            const vatAmount = (calculatedAmount * vatRate) / 100;
            const totalAmount = calculatedAmount + vatAmount;

            debugger
            return {
              requisitionNo: itemData?.requisitionNo || '',
              srno: detail?.srno,
              rsrno: detail?.rsrno,
              ItemNo: detail.itemCode,
              itemDescription: detail?.itemDescription,
              qty: detail?.qty,
              stock: selecteditem.convToInvUOM * detail?.qty,
              baseQty: selecteditem.convToInvUOM,
              uom: detail?.uom,
              baseAmount: detail.unitPrice?.toFixed(currencyPrecision || 3),
              discount: discountPerc,
              discountAmount: Number(discountAmount).toFixed(currencyPrecision),
              calculatedAmount: Number(calculatedAmount).toFixed(currencyPrecision),
              vat: vatRate,
              vatDec: selectedVat?.description,
              vatAmount: Number(vatAmount).toFixed(currencyPrecision),
              amount: Number(totalAmount).toFixed(currencyPrecision),
              specification: detail?.specification || "",
            };
          })
          .filter((row) => row !== null);
        const formattedRows = await Promise.all(formattedRowsPromises);
        if (formattedRows?.length > 0) {
          setLoader(false);
          setRows(formattedRows?.reverse());
          onRequisitionData(formattedRows);
          dispatch(setRows(formattedRows));
        }
      }
    } catch (error) {
      setLoader(false);
      console.error('Error fetching items:', error);
    }
  };
  const fetchItemNo = async (inputValue = '', pageNumber = 1) => {
    if (loader) return;
    setLoaders(true);
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', pageNumber || 1);
      params.append('PageSize', 20);
      params.append('ItemNo', inputValue || '');
      const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
      const fetchedItems = response.data.result.map((item) => ({
        label: item.itemNo,
        value: item,
      }));
      if (fetchedItems.length < 20) setHasMore(false);
      setItemOptions((prevAccounts) => [...prevAccounts, ...fetchedItems]);
      setLoaders(false);
      return fetchedItems;
    } catch (error) {
      console.error('Error fetching account data:', error);
      setLoaders(false);
      return [];
    }
  };
  const fetchItemDesc = async (inputValue = '', pageNumber = 1) => {
    if (loader) return;
    setLoaders(true);
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', pageNumber || 1);
      params.append('PageSize', 20);
      params.append('ItemDescription', inputValue || '');
      const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
      const fetchedItems = response.data.result.map((item) => ({
        label: item.itemDescription,
        value: item,
      }));
      if (fetchedItems.length < 20) setHasMore(false);
      setDescriptionOptions((prevAccounts) => [...prevAccounts, ...fetchedItems]);
      setLoaders(false);
      return fetchedItems;
    } catch (error) {
      console.error('Error fetching account data:', error);
      setLoaders(false);
      return [];
    }
  };
  const loadOptions = async (inputValue, callback) => {
    const options = await fetchItemNo(inputValue, 1);
    callback(options);
  };
  const loadDescOptions = async (inputValue, callback) => {
    const options = await fetchItemDesc(inputValue, 1);
    callback(options);
  };
  const loadMoreOptions = async () => {
    if (!hasMore || loader) return;
    setPage((prevPage) => prevPage + 1);
    await fetchItemNo('', page + 1);
  };
  const loadMoreDescOptions = async () => {
    if (!hasMore || loader) return;
    setDecPage((prevPage) => prevPage + 1);
    await fetchItemDesc('', desPage + 1);
  };
  const handleInputChange = async (index, fieldName, value) => {
    const DB = localStorage.getItem("DataBase");
    const companies = JSON.parse(localStorage.getItem("UserCompanies") || "[]");
    const defaultCompany = companies.find((comp) => comp.dataDB === DB);
    const companyName = defaultCompany?.companyName?.toUpperCase() || "";
    const isYusuf =
      companyName.includes("KANOO") || companyName.includes("ACCOUNTCODE");

    if (!isYusuf) {
      const isDuplicate = rows.some(
        (row, rowIndex) =>
          rowIndex !== index &&
          (row.ItemNo === value || row.itemDescription === value)
      );

      if (isDuplicate) {
        toast.error("Please choose a different item.");
        return;
      }
    }

    if (fieldName === "qty" && Number(value) < 0) {
      toast.warning("Quantity cannot be less than 0.");
      return;
    }

    const updatedRows = await Promise.all(
      rows.map(async (row, rowIndex) => {
        if (rowIndex !== index) return row;

        const updatedRow = {
          ...row,
          [fieldName]: value,
          srno: ("0" + (index + 1)).slice(-2),
        };

        //==========================
        // ITEM NO
        //==========================
        if (fieldName === "ItemNo") {
          const getunit = await apiService.getApiParamater(
            "GET_ITEM_PACK",
            `?ItemNo=${value}`
          );

          const selectedItem = getunit?.data?.result[0];
          const selectedVat = vat?.find(
            (tax) => tax.description === selectedItem?.vat
          );

          if (selectedItem) {
            updatedRow.ItemNo = selectedItem.itemNo;
            updatedRow.itemDescription = selectedItem.itemDescription;
            updatedRow.specification = selectedItem.specification;
            updatedRow.uom = selectedItem.baseUnit;
            updatedRow.baseQty = Number(selectedItem.convToInvUOM || 1);
            updatedRow.stock = 0;
            updatedRow.baseAmount = Number(
              selectedItem.avgPrice || 0
            ).toFixed(currencyPrecision);

            updatedRow.vatDec = selectedVat?.description || "";
            updatedRow.vat = selectedVat?.rate || 0;
          }
        }

        //==========================
        // DESCRIPTION
        //==========================
        if (fieldName === "itemDescription") {
          const selectedItm = descriptionOptions.find(
            (d) => d.label === value
          );

          const getunit = await apiService.getApiParamater(
            "GET_ITEM_PACK",
            `?ItemNo=${selectedItm?.value?.itemNo}`
          );

          const selectedItem = getunit?.data?.result[0];
          const selectedVat = vat?.find(
            (tax) => tax.description === selectedItem?.vat
          );

          if (selectedItem) {
            updatedRow.ItemNo = selectedItem.itemNo;
            updatedRow.itemDescription = selectedItem.itemDescription;
            updatedRow.specification = selectedItem.specification;
            updatedRow.uom = selectedItem.baseUnit;
            updatedRow.baseQty = Number(selectedItem.convToInvUOM || 1);
            updatedRow.stock = 0;
            updatedRow.baseAmount = Number(
              selectedItem.avgPrice || 0
            ).toFixed(currencyPrecision);

            updatedRow.vatDec = selectedVat?.description || "";
            updatedRow.vat = selectedVat?.rate || 0;
          }
        }

        //==========================
        // VAT CHANGED
        //==========================
        if (fieldName === "vat") {
          updatedRow.vat = value.rate;
          updatedRow.vatDec = value.description;
        }

        //==========================
        // CALCULATIONS
        //==========================

        const qty = Number(updatedRow.qty || 0);
        const unitPrice = Number(updatedRow.baseAmount || 0);
        const vatRate = Number(updatedRow.vat || 0);

        updatedRow.stock = qty * Number(updatedRow.baseQty || 1);

        // Amount
        const amount = qty * unitPrice;

        // Discount %
        const discountAmount = (amount * Number(overallDiscount || 0)) / 100;

        // After Discount
        const calculatedAmount = amount - discountAmount;

        // VAT
        const vatAmount = (calculatedAmount * vatRate) / 100;

        // Total
        const totalAmount = calculatedAmount + vatAmount;

        updatedRow.discount = Number(overallDiscount || 0);
        updatedRow.discountAmount = Number(
          discountAmount.toFixed(currencyPrecision)
        );
        updatedRow.calculatedAmount = Number(
          calculatedAmount.toFixed(currencyPrecision)
        );
        updatedRow.vatAmount = Number(
          vatAmount.toFixed(currencyPrecision)
        );
        updatedRow.amount = Number(
          totalAmount.toFixed(currencyPrecision)
        );

        return updatedRow;
      })
    );

    dispatch(setRows(updatedRows));
    onRequisitionData(updatedRows);

    // Footer Totals
    const totalDiscount = updatedRows.reduce(
      (sum, r) => sum + Number(r.discountAmount || 0),
      0
    );

    const totalVat = updatedRows.reduce(
      (sum, r) => sum + Number(r.vatAmount || 0),
      0
    );

    const grandTotal = updatedRows.reduce(
      (sum, r) => sum + Number(r.amount || 0),
      0
    );

    setDiscountAmount(totalDiscount);
    setVatAmount(totalVat);
    setGrandTotal(grandTotal);
  };
  const addNewRow = () => {
    const newRow = {
      srno: '',
      ItemNo: '',
      requisitionNo: '',
      itemDescription: '',
      branch: '',
      qty: '',
      uom: '',
      baseQty: '',
      baseAmount: '',
      specification: '',
      amount: '',
      stock: '',
      bol: '',
    };
    dispatch(addRow(newRow));
    const updatedRows = [...rows, newRow];
    dispatch(setRows(updatedRows));
    onRequisitionData(updatedRows);
  };
  const handleRemoveRow = (originalIndex) => {
    const removedSrNo = rows[originalIndex]?.srno;

    const updatedRows = rows
      .filter((_, index) => index !== originalIndex)
      .map((row, i) => ({
        ...row,
        srno: i + 1,
      }));

    setRows(updatedRows);
    dispatch(setRows(updatedRows));
    dispatch(removeSingleRow(removedSrNo));
    onRequisitionData(updatedRows);
  };
  const preventNegativeSign = (e) => {
    if (e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };
  const handleOverallDiscount = (e) => {
    const percentage = Number(e.target.value) || 0;

    if (percentage > 100) {
      toast.warning("Discount percentage cannot exceed 100%");
      return;
    }

    const updatedRows = rows.map((row) => {
      const amount = Number(row.qty || 0) * Number(row.baseAmount || 0);

      const discountAmount = (amount * percentage) / 100;

      const calculatedAmount = amount - discountAmount;

      const vatRate = Number(row.vat || 0);

      const vatAmount = (calculatedAmount * vatRate) / 100;

      const totalAmount = calculatedAmount + vatAmount;

      return {
        ...row,
        discount: percentage,               // %
        discountAmount,
        calculatedAmount: calculatedAmount?.toFixed(3),
        vatAmount,
        amount: totalAmount,
      };
    });

    dispatch(setRows(updatedRows));
    onRequisitionData(updatedRows);

    setOverallDiscount(percentage);

    setDiscountAmount(
      updatedRows.reduce((sum, r) => sum + Number(r.discountAmount || 0), 0)
    );

    setVatAmount(
      updatedRows.reduce((sum, r) => sum + Number(r.vatAmount || 0), 0)
    );

    setGrandTotal(
      updatedRows.reduce((sum, r) => sum + Number(r.amount || 0), 0)
    );
  };
  return (
    <div>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Discount %</label>
          <input
            type="number"
            className="form-Input w-100"
            min="0"
            max="100"
            value={overallDiscount}
            onChange={handleOverallDiscount}
          />
        </div>
      </div>
      <div className="table-container p-2 mb-5" style={{ overflowX: 'auto', height: '400px' }}>
        {loder === true ? (
          <div className="center p-5">
            <BarLoader color="#6E5199" size={50} height={3} width={300} />
          </div>
        ) : (
          <table>
            <thead className="dynoTable">
              <tr>
                <th></th>
                <th>Sr no</th>
                <th>Item No</th>
                <th>Description</th>
                <th>Item Specs</th>
                <th>Qty</th>
                <th>Packing UOM</th>
                <th>Inventory Qty</th>
                <th>Unit Price</th>
                <th>Calculated Amount</th>
                <th>VAT %</th>
                <th>VAT Amount</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(rows) &&
                rows
                  .map((row, originalIndex) => ({
                    row,
                    originalIndex
                  }))
                  .sort((a, b) => Number(a.row.srno) - Number(b.row.srno))
                  .map(({ row, originalIndex }) => (
                    <tr key={originalIndex}>
                      {itemData?.requisitionNo === '' ? (
                        <td className="m-0 p-0" style={{ border: '1px solid rgba(118, 118, 118, 0.3)' }}>
                          <div className="center"
                            onClick={() => handleRemoveRow(originalIndex)}>
                            {' '}
                            <RxCross1 size={15} />
                          </div>
                        </td>
                      ) : (
                        <td className="m-0 p-0" style={{ border: '1px solid rgba(118, 118, 118, 0.3)' }}>
                          <div className="center">
                            {' '}
                            <RxCross1 size={15} />
                          </div>
                        </td>
                      )}
                      <td className="m-0 p-0">
                        <input className="p-2" type="text" value={row?.srno} disabled style={{ width: '120px' }} />
                      </td>
                      <td className="m-0 p-0 itemCol">
                        {itemData?.requisitionNo === '' ? (
                          <AsyncSelect
                            cacheOptions
                            value={{ value: row.ItemNo, label: row.ItemNo }}
                            options={itemOptions}
                            isDisabled={itemData?.eye === true ? true : false}
                            loadOptions={loadOptions}
                            onChange={(selectedOption) => handleInputChange(originalIndex, 'ItemNo', selectedOption.label)}
                            defaultOptions={itemOptions}
                            onMenuScrollToBottom={loadMoreOptions}
                            className="descSelect"
                            classNamePrefix="descSelect"
                          />
                        ) : (
                          <td className="m-0 p-0">
                            <input className="p-2" disabled value={row?.ItemNo} style={{ width: '100%' }} />
                          </td>
                        )}
                      </td>
                      <td className="m-0 p-0 descriptionCol">
                        {itemData?.requisitionNo === '' ? (
                          <AsyncSelect
                            cacheOptions
                            value={{ value: row.itemDescription, label: row.itemDescription }}
                            isDisabled={itemData?.eye === true ? true : false}
                            options={descriptionOptions}
                            loadOptions={loadDescOptions}
                            onChange={(selectedOption) => handleInputChange(originalIndex, 'itemDescription', selectedOption.label)}
                            className="descSelect"
                            classNamePrefix="descSelect"
                            defaultOptions={descriptionOptions}
                            onMenuScrollToBottom={loadMoreDescOptions}
                          />
                        ) : (
                          <td className="m-0 p-0">
                            <input className="p-2" disabled value={row?.itemDescription} style={{ width: '400px' }} />
                          </td>
                        )}
                      </td>
                      <Tooltip text={row?.specification}>
                        <td className="m-0 p-0">
                          <input
                            className="p-2"
                            type="text"
                            disabled={itemData?.requisitionNo === '' ? false : true}
                            value={row?.specification}
                            onChange={(e) => handleInputChange(originalIndex, 'specification', e.target.value)}
                            style={{ width: '350px' }}
                          />
                        </td>
                      </Tooltip>

                      <td className="m-0 p-0">
                        <input
                          className="p-2"
                          onWheel={(e) => e.target.blur()}
                          style={{ width: '120px' }}
                          type="number"
                            disabled={itemData?.requisitionNo === '' ? false : true}
                          value={row?.qty}
                          onChange={(e) => handleInputChange(originalIndex, 'qty', e.target.value)}
                          onKeyDown={preventNegativeSign}
                        />
                      </td>
                      <td className="m-0 p-0">
                        <input className="p-2" disabled={true} type="text" value={row?.uom} style={{ width: '140px' }} />
                      </td>
                      <td className="m-0 p-0">
                        <input className="p-2" disabled type="text" value={row?.stock || 0} style={{ width: '140px' }} />
                      </td>
                      <td className="m-0 p-0">
                        <input
                          className="p-2"
                          onWheel={(e) => e.target.blur()}
                          style={{ width: '120px' }}
                          type="number"
                          value={row?.baseAmount}
                          onChange={(e) => handleInputChange(originalIndex, 'baseAmount', e.target.value)}
                          onKeyDown={preventNegativeSign}
                        />
                      </td>
                      <td className="m-0 p-0">
                        <input className="p-2" disabled={true} type="text" value={row?.calculatedAmount} style={{ width: '140px' }} />
                      </td>
                      {/* <td className="m-0 p-0">
                        <input
                          className="p-2"
                          // disabled
                          onChange={(e) => handleInputChange(index, 'discount', e.target.value)}
                          onKeyDown={preventNegativeSign}
                          type="number"
                          value={row?.discount}
                          style={{ width: '120px' }}
                        />
                      </td> */}
                      <td className="m-0 p-0 itemCol">
                        <Select
                          className="descSelect"
                          classNamePrefix="descSelect"
                          theme={(theme) => ({
                            ...theme,
                            padding: 10,
                          })}
                          value={{ value: row?.vatDec, label: row?.vatDec }}
                          options={vat?.map((vat) => ({ value: vat, label: vat?.description }))}
                          onChange={(selectedOption) => handleInputChange(originalIndex, 'vat', selectedOption.value)}
                        />
                      </td>
                      <td className="m-0 p-0">
                        <input
                          className="p-2"
                          type="text"
                          value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)}
                          disabled
                          style={{ width: '120px' }}
                        />
                      </td>
                      <td className="m-0 p-0">
                        <input
                          className="p-2"
                          disabled
                          style={{ width: '120px' }}
                          type="text"
                          value={row.amount === NaN ? 0 : Number(row.amount || 0).toFixed(currencyPrecision || 0) || 0}
                        />
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        )}
        {itemData?.requisitionNo === '' ? (
          <div className="d-flex gap-5">
            <button className="mainbtn  mt-4 gap-3" onClick={addNewRow}>
              <div>Add</div> <IoAddSharp color="#fff" className="center mt-1 mx-2" />{' '}
            </button>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="d-flex justify-content-between boxs">
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Amount</div>
          <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">_</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Discount</div>
          <div className="field">{parseFloat(discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">After Discount</div>
          <div className="field">{(calculatedTotal - discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">+</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Vat</div>
          <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Net Amount</div>
          <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
      </div>
    </div>
  );
};

export default UpdateItemGrid;
